module.exports = __webpack_public_path__ + "img/logo.4267d42d.png";